/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-unused-vars */
import {
  Box,
  Flex,
  Link,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from '@tonic-one/react';
import isEqual from 'lodash/isEqual';
import React, { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import ButtonTab from 'src/components/Common/ButtonTab';
import { TitleLabel } from 'src/components/Common/FormComponent';
import NotifyAdmin from 'src/components/FilterNotification/NotifyAdmin';
import NotifyUser from 'src/components/FilterNotification/NotifyUser';
import {
  ActionEnum,
  EnableDisableStatus,
  ExchangeOnlinePolicyItem,
} from 'src/pages/Policy/utils/types';
import { useWhyDidYouUpdate } from 'src/utils/hooks';

import {
  storeSelector,
  templateSelector,
  usePolicyContext,
} from '@Policy/store';
import { PolicyModeEnum, PolicyTypeEnum } from '@Policy/utils/constants';
import Actions from '../../Components/Actions';
import AdvancedOptionModal from '../../Components/AdvancedOptionModal';
import {
  fbActionDataSelector,
  fbAdvancedOptionConfigSelector,
  fbAdvancedSettingsSelector,
} from '@Policy/store/filters/fileBlocking';
import AdvancedSettingsModal from '../../Components/AdvancedSettingsModal';
export const FbBasicAction = () => {
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state from store
  const policySelector = templateSelector(contextStore);
  const policyType = policySelector((s) => s.policyType);
  const actionData = contextSelector(fbActionDataSelector, isEqual);
  const modifiedActionData = useMemo(
    () =>
      actionData.map((item) => {
        const newItem = { ...item };
        if (
          policyType === PolicyTypeEnum.GmailInline ||
          policyType === PolicyTypeEnum.ExchangeInline
        ) {
          if (newItem.action === ActionEnum.delete) {
            newItem.actions.push(ActionEnum.delete);
          }
        }
        return newItem;
      }),
    [actionData, policyType]
  );
  useWhyDidYouUpdate('FileBlocking FbBasicAction', {
    actionData,
  });
  const policyMode = policySelector((s) => s.policyMode);
  return (
    <Actions
      actionData={modifiedActionData}
      disabledAll={policyMode === PolicyModeEnum.DefaultMonitorPolicy}
    />
  );
};
export const FbAdvancedOption = ({
  replaceFileNameShow,
  availableTokenShow,
}: {
  availableTokenShow: boolean;
  replaceFileNameShow: boolean;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(contextStore);
  // get state and action from store
  const advancedOptionConfig = contextSelector(
    fbAdvancedOptionConfigSelector,
    isEqual
  );

  // get action from store
  const setFbState = contextSelector((s) => s.setFbState);
  // advanced option
  const [isVisible, setIsVisible] = React.useState(false);
  const handleAdvancedOptionClose = React.useCallback(() => {
    setIsVisible(false);
  }, []);
  const policyType = policySelector((s) => s.policyType);
  const handleAdvancedOptionSave = React.useCallback(
    ({
      replaceFileName,
      replaceText,
    }: {
      replaceFileName: string;
      replaceText: string;
    }) => {
      setFbState({
        fbReplacementFileName: replaceFileName,
        fbReplacementText: replaceText,
      });
    },
    []
  );
  useWhyDidYouUpdate('FileBlocking FbAdvancedOption', {
    advancedOptionConfig,
    isVisible,
  });
  return (
    <>
      <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
        {t('policy.action.advanced.title')}
      </Link>
      <AdvancedOptionModal
        replacementTextDesc={
          [
            PolicyTypeEnum.SharePoint,
            PolicyTypeEnum.OneDrive,
            PolicyTypeEnum.Box,
            PolicyTypeEnum.Dropbox,
            PolicyTypeEnum.GoogleDrive,
            PolicyTypeEnum.Teams,
          ].includes(policyType)
            ? t('policy.action.replaceAction.quarantineOrDelete.desc')
            : t('policy.action.replaceAction.desc')
        }
        availableTokenShow={availableTokenShow}
        replaceFileNameShow={replaceFileNameShow}
        isVisible={isVisible}
        onClose={handleAdvancedOptionClose}
        config={advancedOptionConfig}
        saveConfig={handleAdvancedOptionSave}
      />
    </>
  );
};

export const FbAdvancedSettings4Files = ({
  availableTokenShow,
}: {
  availableTokenShow: boolean;
}) => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  // get state and action from store
  const advancedSettingsConfig = contextSelector(
    fbAdvancedSettingsSelector,
    isEqual
  );
  const setFbState = contextSelector((s) => s.setFbState);
  // local state
  const [isVisible, setIsVisible] = React.useState<boolean>(false);
  // advanced optino
  const handleAdvancedSettings4FilesClose = useCallback(() => {
    setIsVisible(false);
  }, []);
  const handleAdvancedSettingsSave = useCallback(
    (config: {
      secondActionEnabled: number;
      secondActionType: number;
      replaceFileTagContent: string;
      replaceText: string;
    }) => {
      // save config
      setFbState({
        fbSecondActionEnabled: config.secondActionEnabled,
        fbSecondActionType: config.secondActionType,
        fbFileTagContent: config.replaceFileTagContent,
        fbReplacementText: config.replaceText,
      });
      // close the modal
      setIsVisible(false);
    },
    []
  );
  useWhyDidYouUpdate('FileBlocking FbAdvancedSettings4Files', {
    advancedSettingsConfig,
    isVisible,
  });
  return (
    <>
      <Link mr="24px" onClick={() => setIsVisible(!isVisible)}>
        {t('policy.action.advancedSettings.title')}
      </Link>
      <AdvancedSettingsModal
        availableTokenShow={availableTokenShow}
        isVisible={isVisible}
        onClose={handleAdvancedSettings4FilesClose}
        config={advancedSettingsConfig}
        saveConfig={handleAdvancedSettingsSave}
      />
    </>
  );
};

export const FbNotification = () => {
  const { t } = useTranslation();
  // get store from context
  const contextStore = usePolicyContext();
  // get store selector
  const contextSelector = storeSelector(contextStore);
  const policySelector = templateSelector(
    contextStore
  )<ExchangeOnlinePolicyItem>;
  // get state and action from store
  const ntfEnableNotifyRecipient = policySelector(
    (s) => s.tmFileblockings.notification.ntfEnableNotifyRecipient
  );
  const ntfInternalRecipientSubject = policySelector(
    (s) => s.tmFileblockings.notification.ntfInternalRecipientSubject
  );
  const ntfInternalRecipientMessage = policySelector(
    (s) => s.tmFileblockings.notification.ntfInternalRecipientMessage
  );
  const ntfEnableNotifyAdmin = policySelector(
    (s) => s.tmFileblockings.notification.ntfEnableNotifyAdmin
  );
  const ntfToAccount = policySelector(
    (s) => s.tmFileblockings.notification.ntfToAccount
  );
  const ntfAdminSubject = policySelector(
    (s) => s.tmFileblockings.notification.ntfAdminSubject
  );
  const ntfAdminMessage = policySelector(
    (s) => s.tmFileblockings.notification.ntfAdminMessage
  );
  const ntfAdminNotifySettingType = policySelector(
    (s) => s.tmFileblockings.notification.ntfAdminNotifySettingType
  );
  const ntfAdminIntervalNum = policySelector(
    (s) => s.tmFileblockings.notification.ntfAdminIntervalNum
  );
  const ntfAdminIntervalType = policySelector(
    (s) => s.tmFileblockings.notification.ntfAdminIntervalType
  );
  const ntfAdminOccurenceNum = policySelector(
    (s) => s.tmFileblockings.notification.ntfAdminOccurenceNum
  );
  const ntfRecipientGroupId = policySelector(
    (s) => s.tmFileblockings.notification.ntfRecipientGroupId
  );
  const ntfRecipientGroupEnabled = policySelector(
    (s) => s.tmFileblockings.notification.ntfRecipientGroupEnabled
  );
  const recipientGroups = contextSelector((s) => s.recipientGroups);

  // get action from store
  const setFbNtfState = contextSelector((s) => s.setFbNtfState);
  // local state
  const handleNtfEnableAdminChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFbNtfState({
        ntfEnableNotifyAdmin: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfAdminToAccountChange = React.useCallback((account: string) => {
    setFbNtfState({ ntfToAccount: account });
  }, []);
  const handleNtfAdminNotifySettingTypeChange = React.useCallback(
    (type: number) => {
      setFbNtfState({ ntfAdminNotifySettingType: type });
    },
    []
  );
  const handleNtfAdminSubjectChange = React.useCallback((subject: string) => {
    setFbNtfState({ ntfAdminSubject: subject });
  }, []);
  const handleNtfAdminMessageChange = React.useCallback((message: string) => {
    setFbNtfState({ ntfAdminMessage: message });
  }, []);
  const handleNtfAdminIntervalNumChange = React.useCallback((num: number) => {
    setFbNtfState({ ntfAdminIntervalNum: num });
  }, []);
  const handleNtfAdminIntervalTypeChange = React.useCallback((type: number) => {
    setFbNtfState({ ntfAdminIntervalType: type });
  }, []);
  const handleNtfAdminOccurenceNumChange = React.useCallback((num: number) => {
    setFbNtfState({ ntfAdminOccurenceNum: num });
  }, []);
  const handleNtfRecipientGroupIdChange = React.useCallback(
    (recipientGroupId: number) => {
      setFbNtfState({ ntfRecipientGroupId: recipientGroupId });
    },
    []
  );
  const handleNtfRecipientGroupEnabledChange = React.useCallback(
    (enabled: EnableDisableStatus) => {
      setFbNtfState({ ntfRecipientGroupEnabled: enabled });
    },
    []
  );
  // notify user
  const handleNtfEnableUserChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      setFbNtfState({
        ntfEnableNotifyRecipient: e.target.checked ? 1 : 0,
      });
    },
    []
  );
  const handleNtfUserSubjectChange = React.useCallback((subject: string) => {
    setFbNtfState({ ntfInternalRecipientSubject: subject });
  }, []);
  const handleNtfUserMessageChange = React.useCallback((message: string) => {
    setFbNtfState({ ntfInternalRecipientMessage: message });
  }, []);

  useWhyDidYouUpdate('File blocking FbNotification', {
    ntfEnableNotifyRecipient,
    ntfAdminIntervalNum,
    ntfAdminIntervalType,
    ntfAdminOccurenceNum,
    ntfEnableNotifyAdmin,
    ntfToAccount,
    ntfAdminNotifySettingType,
    ntfAdminSubject,
    ntfAdminMessage,
    ntfInternalRecipientSubject,
    ntfInternalRecipientMessage,
    recipientGroups,
    ntfRecipientGroupId,
  });
  return (
    <Tabs mt="24px">
      <TabList>
        <ButtonTab>{t('policy.notification.admin')}</ButtonTab>
        <ButtonTab>{t('policy.notification.user')}</ButtonTab>
      </TabList>
      <TabPanels py="24px">
        <TabPanel>
          <NotifyAdmin
            status={ntfEnableNotifyAdmin}
            toAccount={ntfToAccount}
            notifySettingType={ntfAdminNotifySettingType}
            subject={ntfAdminSubject}
            message={ntfAdminMessage}
            intervalNum={ntfAdminIntervalNum}
            intervalType={ntfAdminIntervalType}
            occurenceNum={ntfAdminOccurenceNum}
            recipientGroups={recipientGroups}
            recipientGroupId={ntfRecipientGroupId}
            recipientGroupEnabled={ntfRecipientGroupEnabled}
            setStatus={handleNtfEnableAdminChange}
            setToAccount={handleNtfAdminToAccountChange}
            setNotifySettingType={handleNtfAdminNotifySettingTypeChange}
            setSubject={handleNtfAdminSubjectChange}
            setMessage={handleNtfAdminMessageChange}
            setIntervalNum={handleNtfAdminIntervalNumChange}
            setIntervalType={handleNtfAdminIntervalTypeChange}
            setOccurenceNum={handleNtfAdminOccurenceNumChange}
            setRecipientGroupId={handleNtfRecipientGroupIdChange}
            setRecipientGroupEnabled={handleNtfRecipientGroupEnabledChange}
          />
        </TabPanel>
        <TabPanel>
          <NotifyUser
            status={ntfEnableNotifyRecipient}
            subject={ntfInternalRecipientSubject}
            message={ntfInternalRecipientMessage}
            setStatus={handleNtfEnableUserChange}
            setSubject={handleNtfUserSubjectChange}
            setMessage={handleNtfUserMessageChange}
          />
        </TabPanel>
      </TabPanels>
    </Tabs>
  );
};

function ActionNotification({
  advancedOptionShow,
  replaceFileNameShow = true,
  availableTokenShow = false,
  advancedSettings4FilesShow = false,
}: {
  advancedOptionShow: boolean;
  replaceFileNameShow?: boolean;
  availableTokenShow?: boolean;
  advancedSettings4FilesShow?: boolean;
}) {
  const { t } = useTranslation();
  return (
    <div>
      <Box ml="1px" mt="16px" width="100%">
        <Flex direction="column">
          <TitleLabel title={t('policy.action')} mb="24px" />
          <FbBasicAction />
          {advancedOptionShow ? (
            <Flex mb="24px" mt="16px">
              <FbAdvancedOption
                availableTokenShow={availableTokenShow}
                replaceFileNameShow={replaceFileNameShow}
              />
            </Flex>
          ) : null}
          {advancedSettings4FilesShow ? (
            <Flex mb="24px" mt="16px">
              <FbAdvancedSettings4Files
                availableTokenShow={availableTokenShow}
              />
            </Flex>
          ) : null}
          <TitleLabel title={t('policy.notification')} />
          <FbNotification />
        </Flex>
      </Box>
    </div>
  );
}

export default React.memo(ActionNotification);
